import React from 'react';
import { motion } from 'framer-motion';

import useAnimate from '../ui/Motion';

import SectionHead from './SectionHead';

const EASE = [0.16, 1, 0.3, 1];

/**
 * A numbered index of services. Rows rather than cards: a service list
 * is a reference, and a reader scanning for one name should not have to
 * cross eight boxes of chrome to find it.
 */
export default function ServiceList({ eyebrow, title, lead, items, id }) {
    const reduced = !useAnimate();

    return (
        <section className="section section--ruled" id={id}>
            <div className="shell">
                <SectionHead eyebrow={eyebrow} title={title} lead={lead} />

                <ul className="svc" style={{ marginTop: 'clamp(2.5rem, 6vw, 4rem)' }}>
                    {items.map((item, i) => (
                        <motion.li
                            className="svc__row"
                            key={item.title}
                            initial={reduced ? false : { opacity: 0, y: 24 }}
                            whileInView={{ opacity: 1, y: 0 }}
                            viewport={{ once: true, amount: 0.3 }}
                            transition={{ duration: 0.7, delay: (i % 2) * 0.08, ease: EASE }}
                        >
                            <span className="svc__num">{String(i + 1).padStart(2, '0')}</span>
                            <div>
                                <h3 className="svc__title">{item.title}</h3>
                                <p className="svc__copy">{item.text}</p>
                            </div>
                        </motion.li>
                    ))}
                </ul>
            </div>
        </section>
    );
}
